// Cal Poly Pomona's undergraduate majors (#2596, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-09-30 from CPP's
// official 2026-2027 University Catalog: the Index of Academic Programs,
// Bachelor list (catalog.cpp.edu/content.php?catoid=78&navoid=7065), with each
// program placed in its college by that college's own catalog page
// (navoid=7007 to 7014), which is each group's source. The catalog lists every
// subplan/option as its own line ("Business Administration, B.S. - Accounting
// Subplan/Option"); an option is not a separate major, so each major and degree
// appears once, with its options in the note. The College of Professional and
// Global Education offers no bachelor's degree. The Bachelor (ADT) list is
// transfer-only roadmaps and is left out. Flags quote CPP's first-year impacted
// majors page (the college file's `impacted` source) as of 2026-09-30:
// Business Administration is impacted only in two options, and Kinesiology
// (General) is not flagged because it is no longer impacted beginning with the
// fall 2027 cycle. The "(R)" mark after Culinology is dropped for plain ASCII.
// The KB's list was the starting point; the catalog wins.
const majors = {
    "slug": "california-state-polytechnic-university-pomona",
    "read": "2026-09-30",
    "intro": "Every bachelor's degree in Cal Poly Pomona's official 2026-2027 University Catalog, grouped by the college that offers it, with the degree it leads to. Options are listed under their major; minors, transfer-only pathways and graduate programs are left out.",
    "groups": [
        {
            "name": "Don B. Huntley College of Agriculture",
            "source": {
                "label": "Cal Poly Pomona 2026-2027 University Catalog, Don B. Huntley College of Agriculture",
                "url": "https://catalog.cpp.edu/content.php?catoid=78&navoid=7007"
            },
            "majors": [
                {
                    "name": "Agribusiness and Food Industry Management",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Science",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Health Science",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Animal Science",
                    "degree": "B.S.",
                    "note": "Options: Animal Science; Pre-Veterinary Science/Graduate School.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Fashion Design, Technology, and Management",
                    "degree": "B.S.",
                    "note": "Options: Design and Production; Fashion Retailing; Textile Technology and Sustainability."
                },
                {
                    "name": "Food Science and Technology",
                    "degree": "B.S.",
                    "note": "Options: Culinology; General; Science and Technology."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S.",
                    "note": "Options: Dietetics; Nutrition and Health; Nutrition Science."
                },
                {
                    "name": "Plant Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Business Administration",
            "source": {
                "label": "Cal Poly Pomona 2026-2027 University Catalog, College of Business Administration",
                "url": "https://catalog.cpp.edu/content.php?catoid=78&navoid=7008"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "B.S.",
                    "note": "Options: Accounting; Computer Information Systems; E-Business; Finance, Real Estate, and Law; International Business; Management and Human Resources; Marketing Management; Technology and Operations Management.",
                    "flag": "Impacted for the Accounting option, and for the Finance, Real Estate, and Law option beginning with the fall 2027 term: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                }
            ]
        },
        {
            "name": "College of Education and Integrative Studies",
            "source": {
                "label": "Cal Poly Pomona 2026-2027 University Catalog, College of Education and Integrative Studies",
                "url": "https://catalog.cpp.edu/content.php?catoid=78&navoid=7009"
            },
            "majors": [
                {
                    "name": "Early Childhood Studies",
                    "degree": "B.A.",
                    "note": "Options: Early Childhood Teaching; Multilingual Teaching; PK-Grade 3."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A.",
                    "note": "Options: General Studies; Pre-Credential."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Cal Poly Pomona 2026-2027 University Catalog, College of Engineering",
                "url": "https://catalog.cpp.edu/content.php?catoid=78&navoid=7010"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.",
                    "note": "Options: Environmental Engineering; General Civil Engineering; Geospatial Engineering.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Construction Engineering and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Electromechanical Systems Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Electronic Systems Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Manufacturing Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                }
            ]
        },
        {
            "name": "College of Environmental Design",
            "source": {
                "label": "Cal Poly Pomona 2026-2027 University Catalog, College of Environmental Design",
                "url": "https://catalog.cpp.edu/content.php?catoid=78&navoid=7011"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "B.S."
                },
                {
                    "name": "Urban and Regional Planning",
                    "degree": "B.S.",
                    "note": "Options: Community Development and Social Justice; Infrastructure and Transportation; Resiliency, Sustainability and the Environment; Urban Design."
                },
                {
                    "name": "Visual Communication Design",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "College of Letters, Arts, and Social Sciences",
            "source": {
                "label": "Cal Poly Pomona 2026-2027 University Catalog, College of Letters, Arts, and Social Sciences",
                "url": "https://catalog.cpp.edu/content.php?catoid=78&navoid=7012"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.S.",
                    "note": "Options: Applied Anthropology; Archaeology; General Anthropology."
                },
                {
                    "name": "Communication",
                    "degree": "B.S.",
                    "note": "Options: Communication Studies; Multimedia Journalism; Public Relations."
                },
                {
                    "name": "Criminology",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.",
                    "note": "Options: Applied Economics; General Economics; Quantitative Economics."
                },
                {
                    "name": "English",
                    "degree": "B.A.",
                    "note": "Options: Applied Linguistics; English Education; Literary Studies."
                },
                {
                    "name": "Gender, Ethnicity, and Multicultural Studies",
                    "degree": "B.A.",
                    "note": "Options: GEMS; Pre-Credential."
                },
                {
                    "name": "Geography",
                    "degree": "B.S.",
                    "note": "Options: Environmental Studies; Geospatial Analysis."
                },
                {
                    "name": "History",
                    "degree": "B.A.",
                    "note": "Option: Pre-Credential."
                },
                {
                    "name": "Music",
                    "degree": "B.A.",
                    "note": "Options: General; Music Industry Studies."
                },
                {
                    "name": "Music",
                    "degree": "B.M.",
                    "note": "Options: Composition; Music Education Pre-credential; Performance."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A.",
                    "note": "Options: General; Law and Society."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Science, Technology, and Society",
                    "degree": "B.A.",
                    "note": "Option: Artificial Intelligence Ethics and Society."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A.",
                    "note": "Options: General Sociology; Social Work."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A.",
                    "note": "Options: Acting; Dance Theatre; Design and Technical Production; General Theatre; Theatre in Education and Community Engagement."
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "Cal Poly Pomona 2026-2027 University Catalog, College of Science",
                "url": "https://catalog.cpp.edu/content.php?catoid=78&navoid=7013"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Biotechnology",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S.",
                    "note": "Options: American Chemical Society; Biochemistry; General Chemistry.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Environmental Biology",
                    "degree": "B.S.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S.",
                    "note": "Options: General; Physical Education Teacher Education."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S.",
                    "note": "Options: Applied Mathematics/Statistics; Secondary Teacher Prep/Pure Mathematics."
                },
                {
                    "name": "Physics",
                    "degree": "B.S.",
                    "note": "Options: Biophysics; General; Integrated Science.",
                    "flag": "Impacted: admission is competitive and can take higher academic standards or major-specific criteria beyond the CSU minimum.",
                    "flagSource": "impacted"
                }
            ]
        },
        {
            "name": "The Collins College of Hospitality Management",
            "source": {
                "label": "Cal Poly Pomona 2026-2027 University Catalog, The Collins College of Hospitality Management",
                "url": "https://catalog.cpp.edu/content.php?catoid=78&navoid=7014"
            },
            "majors": [
                {
                    "name": "Hospitality Management",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
